import React, {FC} from 'react';
import {IconType} from 'react-icons';
import SurfaceCard from '../../../components/SurfaceCard';
import {Box, BoxProps, Icon, VStack} from 'components/ui/chakra';

interface IconBoxButtonProps extends BoxProps {
	icon: IconType;
	label: string;
	onClick: () => void;
}

const IconBoxButton: FC<IconBoxButtonProps> = ({label, icon, onClick, ...rest}) => (
	<SurfaceCard
		as={Box}
		onClick={onClick}
		role='button'
		color='subtleText'
		p={{base: 4, md: 8}}
		w='full'
		_hover={{
			backgroundColor: 'panelMuted',
			color: 'clay.600',
			borderColor: 'clay.200',
			transform: 'translateY(-2px)',
		}}
		transition='all 0.2s ease'
		{...rest}
	>
		<VStack gap={3}>
			<Box>
				<Icon as={icon} boxSize={{base: 12, md: 16}} />
			</Box>
			<Box fontWeight='600' textAlign='center'>
				{label}
			</Box>
		</VStack>
	</SurfaceCard>
);

export default IconBoxButton;
